import React from "react";
import { Edit, SimpleForm, NumberInput, Loading } from "react-admin";
import Grid from "@material-ui/core/Grid";
import WithProps from "../Custom/WithProps";
import { makeStyles } from "@material-ui/core/styles";
import { validatePositiveNumber2 } from "../../utils/Validations";
import { EditToolBar } from "../Signet/util";

const useStyles = makeStyles({
  container: {
    width: "100%",
  },
});

const PreciousInlayPricingEdit = (props) => {
  const classes = useStyles();
  const { permissions } = props;

  if (!permissions) return <Loading />;
  const permissionsList = permissions.split(",");

  return (
    <Edit {...props} className="overflow-visible">
      <WithProps>
        {({ record, ...rest }) => (
          <SimpleForm
            record={record}
            {...rest}
            undoable={false}
            toolbar={
              <EditToolBar delete={permissionsList.includes("view_import_export")} />
            }
          >
            <Grid container className={classes.container} spacing={2}>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="quantity"
                  label="Quantity"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="width"
                  label="Width"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="volume_delta"
                  label="Volume Delta"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="labor"
                  label="Labor"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="silver_markup"
                  label="Silver Markup"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="10k_markup"
                  label="10k Markup"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="14k_markup"
                  label="14k Markup"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="18k_markup"
                  label="18k Markup"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="platinum_markup"
                  label="Platinum Markup"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput
                  source="palladium_markup"
                  label="Palladium Markup"
                  validate={[validatePositiveNumber2]}
                  fullWidth
                />
              </Grid>
            </Grid>
          </SimpleForm>
        )}
      </WithProps>
    </Edit>
  );
};

export default PreciousInlayPricingEdit;
